
import store from '@/store';

export function hasRole (...roles: string[]): boolean {
  roles = (roles || []).filter(role => !!role);
  if (roles.length === 0) {
    return true;
  }
  const user = store.getters['user/user'];
  if (!user) {
    throw new Error('unable to validate roles of ' + user + ' user');
  }
  return roles.map(role => {
    return user.roles.indexOf(role) !== -1;
  }).reduce((t, i) => t && i, true);
}

export function hasAnyRole (...roles: string[]): boolean {
  roles = (roles || []).filter(role => !!role);
  if (roles.length === 0) {
    return true;
  }
  const user = store.getters['user/user'];
  if (!user) {
    throw new Error('unable to validate roles of ' + user + ' user');
  }
  return roles.map(role => {
    return user.roles.indexOf(role) !== -1;
  }).reduce((t, i) => t || i, false);
}
